export const ontimeEditable = {
  input: {
    borderRadius: '3px',
    width: '100%',
    _focus: {
      border: '1px solid #578AF4', // $blue-500
      boxShadow: 'none',
    },
  },
  preview: {
    width: '100%',
    border: '1px solid transparent', // $blue-500
  },
};
